define('views/components/distributor_personal/distributor_personal',['require','backbone','text!templates/components/distributor_personal/distributor_personal.html'],function(require){

    var Backbone = require('backbone');

    var temp = require("text!templates/components/distributor_personal/distributor_personal.html");
    return Backbone.Marionette.ItemView.extend({
        tagName: 'tr',
        template: _.template(temp),
        className: 'distirbutor-personal-item'
    });
});
